import { render, staticRenderFns } from "./reportFornitore.vue?vue&type=template&id=2aad35e5&"
import script from "./reportFornitore.vue.ts?vue&type=script&lang=ts&"
export * from "./reportFornitore.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports